import { nextLiveBroadcastSelector } from 'features/broadcast/selectors';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useAppSelector } from 'hooks/redux';
import React, { FunctionComponent, useContext } from 'react';
import { NavLink } from 'react-router-dom';

export const ChatMenu: FunctionComponent = () => {
  const { isCreatorAppWebview } = useContext(UserAgentContext);
  const currentState = useAppSelector((state) => state);
  const liveBroadcast = nextLiveBroadcastSelector(currentState);
  const applyLinkClasses = (isActive: any) => {
    const linkClasses = [
      'tw-block tw-rounded-full tw-px-6 tw-py-2 tw-min-w-[130px] tw-text-center tw-text-black'
    ];
    if (isActive)
      linkClasses.push('tw-bg-theme-color [.dark-contrast_&]:tw-text-white');
    return linkClasses.join(' ');
  };

  if (!isCreatorAppWebview) {
    return null;
  }

  if (!liveBroadcast?.isLive) {
    return null;
  }

  return (
    <div className="tw-text-center tw-mt-8 [.creator-da_&]:tw-mt-2 [.ios-creator_&]:tw-mt-4 [.ios-listener_&]:tw-mt-0 [.android_&]:tw-mt-0 standalone:tw-mt-0">
      <ul className="list--reset tw-flex tw-bg-light-background tw-rounded-full tw-inline-flex tw-p-1 tw-mb-4 md:tw-mb-8">
        <li>
          <NavLink
            to="/chat"
            state={{ animate: false }}
            className={({ isActive }) => applyLinkClasses(isActive)}
          >
            Chat
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/crowd"
            state={{ animate: false }}
            className={({ isActive }) => applyLinkClasses(isActive)}
          >
            Crowd
          </NavLink>
        </li>
      </ul>
    </div>
  );
};
